import React from 'react';
import { Helmet } from 'react-helmet-async';
import './Contact.css';
import ersanLogo from '../ersandoviz.png';

const Contact = () => {
  return (
    <div className="contact">
      <Helmet>
        <title>İletişim | Erşan Döviz - İzmir Şubeleri ve İletişim Bilgileri</title>
        <meta name="description" content="Erşan Döviz İletişim - İzmir'de 4 şubemiz ile hizmetinizdeyiz. Balçova, Urla, Karşıyaka ve Çamıkebir şubelerimizden bize ulaşabilirsiniz. Telefon: 0232 277 12 81" />
        <meta name="keywords" content="Erşan Döviz iletişim, Erşan Döviz şubeleri, İzmir döviz bürosu adres, Balçova döviz, Urla döviz, Karşıyaka döviz, Çamıkebir döviz, Erşan telefon, döviz bürosu iletişim" />
        <link rel="canonical" href="https://ersandoviz.com/iletisim" />
        <meta property="og:title" content="İletişim | Erşan Döviz - İzmir Şubeleri ve İletişim Bilgileri" />
        <meta property="og:description" content="Erşan Döviz İletişim - İzmir'de 4 şubemiz ile hizmetinizdeyiz. Balçova, Urla, Karşıyaka ve Çamıkebir şubelerimizden bize ulaşabilirsiniz." />
        <meta property="og:url" content="https://ersandoviz.com/iletisim" />
        <meta property="og:type" content="website" />
      </Helmet>
      {/* Hero Section */}
      <section className="contact-hero">
        <div className="container">
          <div className="contact-hero-content text-center">
            <h1 className="contact-title">İletişim</h1>
            <p className="contact-subtitle">
              Size nasıl yardımcı olabiliriz? Bizimle iletişime geçin
            </p>
          </div>
        </div>
      </section>

      {/* Contact Info Section */}
      <section className="contact-info section-padding">
        <div className="container">
          <div className="row">
            <div className="col-md-4">
              <div className="info-card card">
                <div className="info-icon">
                  <svg width="48" height="48" viewBox="0 0 24 24" fill="none">
                    <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z" fill="url(#locationGradient)"/>
                    <defs>
                      <linearGradient id="locationGradient" x1="0%" y1="0%" x2="100%" y2="100%">
                        <stop offset="0%" stopColor="#667eea"/>
                        <stop offset="100%" stopColor="#764ba2"/>
                      </linearGradient>
                    </defs>
                  </svg>
                </div>
                <h3 className="info-title">Adresimiz</h3>
                <p className="info-text">
                  Eğitim Mah. Ata Cad. <br />
                  No: 1C/C<br />
                  Balçova - İzmir
                </p>
              </div>
            </div>
            <div className="col-md-4">
              <div className="info-card card">
                <div className="info-icon">
                  <svg width="48" height="48" viewBox="0 0 24 24" fill="none">
                    <path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z" fill="url(#phoneGradient)"/>
                    <defs>
                      <linearGradient id="phoneGradient" x1="0%" y1="0%" x2="100%" y2="100%">
                        <stop offset="0%" stopColor="#f093fb"/>
                        <stop offset="100%" stopColor="#f5576c"/>
                      </linearGradient>
                    </defs>
                  </svg>
                </div>
                <h3 className="info-title">Telefon</h3>
                <p className="info-text">
                  <a href="tel:+902322771281">+90 (232) 277 12 81</a><br />
                  <a href="tel:+902322779981">+90 (232) 277 99 81</a>
                </p>
              </div>
            </div>
            <div className="col-md-4">
              <div className="info-card card">
                <div className="info-icon">
                  <svg width="48" height="48" viewBox="0 0 24 24" fill="none">
                    <path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z" fill="url(#emailGradient)"/>
                    <defs>
                      <linearGradient id="emailGradient" x1="0%" y1="0%" x2="100%" y2="100%">
                        <stop offset="0%" stopColor="#4facfe"/>
                        <stop offset="100%" stopColor="#00f2fe"/>
                      </linearGradient>
                    </defs>
                  </svg>
                </div>
                <h3 className="info-title">E-posta</h3>
                <p className="info-text">
                  <a href="mailto:info@ersandoviz.com">info@ersandoviz.com</a><br />
                  <a href="mailto:destek@ersandoviz.com">destek@ersandoviz.com</a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Branches Section */}
      <section className="branches section-padding">
        <div className="container">
          <div className="section-header text-center">
            <h2 className="section-title">Şubelerimiz</h2>
            <p className="section-description">
              İzmir'de 4 farklı lokasyonda hizmet veriyoruz
            </p>
          </div>
          <div className="branches-grid">
            {/* Merkez Şube */}
            <div className="branch-card main-branch">
              <div className="branch-content">
                <h3 className="branch-title">Erşan Yetkili Müessese Anonim Şirketi | Merkez Şube</h3>
                <div className="branch-info">
                  <div className="info-item">
                    <div className="info-icon">📍</div>
                    <div className="info-text">
                      <strong>Eğitim Mah. Ata Cad. No: 1C/C</strong><br />
                      Balçova - İzmir
                    </div>
                  </div>
                  <div className="info-item">
                    <div className="info-icon">📞</div>
                    <div className="info-text">
                      <strong>0 232 277 12 81</strong><br />
                      0 232 277 99 81
                    </div>
                  </div>
                </div>
                <div className="branch-map">
                  <iframe
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3127.0177429929563!2d27.0580608!3d38.394838799999995!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14bbdc14e4fb5d4d%3A0xa65abc79c1b69b01!2zRXLFn2FuIETDtnZpeiBZZXRraWxpIE3DvGVzc2VzZQ!5e0!3m2!1str!2str!4v1754313786646!5m2!1str!2str"
                    width="100%"
                    height="200"
                    style={{ border: 0, borderRadius: '12px' }}
                    allowFullScreen=""
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                    title="Merkez Şube Haritası"
                  ></iframe>
                </div>
              </div>
            </div>

            {/* Diğer Şubeler */}
            <div className="branches-row">
              {/* Deniz Şubesi */}
              <div className="branch-card">
                <div className="branch-content">
                  <h3 className="branch-title">Erşan Yetkili Müessese Anonim Şirketi | Deniz Şubesi</h3>
                  <div className="branch-info">
                    <div className="info-item">
                      <div className="info-icon">📍</div>
                      <div className="info-text">
                        <strong>Hacı İsa Mahallesi</strong><br />
                        Bülent Baratalı Bulvarı No: 50E<br />
                        Urla/İzmir
                      </div>
                    </div>
                  </div>
                  <div className="branch-map">
                    <iframe
                      src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3130.0258513167905!2d26.764482076350287!3d38.32523218026056!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14bb936226eb70ed%3A0x86672d77f21294e6!2zSGFjxLEgxLBzYSwgQsO8bGVudCBCYXJhdGFsxLEgQmx2LiBObzo1MCwgMzU0MzAgVXJsYS_EsHptaXI!5e0!3m2!1str!2str!4v1754314242191!5m2!1str!2str"
                      width="100%"
                      height="150"
                      style={{ border: 0, borderRadius: '8px' }}
                      allowFullScreen=""
                      loading="lazy"
                      referrerPolicy="no-referrer-when-downgrade"
                      title="Deniz Şubesi Haritası"
                    ></iframe>
                  </div>
                </div>
              </div>

              {/* Merkez Şubesi (İkinci) */}
              <div className="branch-card">
                <div className="branch-content">
                  <h3 className="branch-title">Erşan Yetkili Müessese Anonim Şirketi | İzmir Merkez Şubesi</h3>
                  <div className="branch-info">
                    <div className="info-item">
                      <div className="info-icon">📍</div>
                      <div className="info-text">
                        <strong>Bostanlı Malı.</strong><br />
                        Cemal Bülbül Sk. Einlıolu No: 19 B<br />
                        Karşıyaka/İzmir
                      </div>
                    </div>
                  </div>
                  <div className="branch-map">
                    <iframe
                      src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3124.2881476308826!2d27.097559899999997!3d38.457908499999995!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14bbd993488a29fd%3A0xa682b5635df8c2ca!2zRVLFnkFOIETDllbEsFogU0lOSVJMSSBZRVRLxLAgTcOcRVNTRVNF!5e0!3m2!1str!2str!4v1754314665223!5m2!1str!2str"
                      width="100%"
                      height="150"
                      style={{ border: 0, borderRadius: '8px' }}
                      allowFullScreen=""
                      loading="lazy"
                      referrerPolicy="no-referrer-when-downgrade"
                      title="Karşıyaka Şubesi Haritası"
                    ></iframe>
                  </div>
                </div>
              </div>

              {/* Küçükoba Şubesi */}
              <div className="branch-card">
                <div className="branch-content">
                  <h3 className="branch-title">Erşan Yetkili Müessese Anonim Şirketi | Küçükoba Şubesi</h3>
                  <div className="branch-info">
                    <div className="info-item">
                      <div className="info-icon">📍</div>
                      <div className="info-text">
                        <strong>Camikebir Mahallesi</strong><br />
                        52/4 Sokak Nilas 1<br />
                        İnş Sitesi No: 3/A<br />
                        Seferihisar/İzmir
                      </div>
                    </div>
                  </div>
                  <div className="branch-map">
                    <iframe
                      src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d783.9014679162046!2d26.84133175089826!3d38.19582821070692!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14bbf2f8cda3b3db%3A0x7a90b82688e359a5!2s52%2F4.%20Sk.%2C%20Seferihisar%2F%C4%B0zmir!5e0!3m2!1str!2str!4v1754314695452!5m2!1str!2str"
                      width="100%"
                      height="150"
                      style={{ border: 0, borderRadius: '8px' }}
                      allowFullScreen=""
                      loading="lazy"
                      referrerPolicy="no-referrer-when-downgrade"
                      title="Seferihisar Şubesi Haritası"
                    ></iframe>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact;